import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';
import { composeExitGuard } from './screens/compose/compose-exit.guard';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        path: 'wa-optin/:schoolCode',
        loadComponent: () => import('./wa-optin-page/wa-optin-page.component').then(m => m.WaOptinPageComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'overview', pathMatch: 'full' },
            {
                path: 'overview',
                loadComponent: () => import('./screens/overview/overview.component').then(m => m.OverviewComponent)
            },
            {
                path: 'compose',
                canDeactivate: [composeExitGuard],
                loadComponent: () => import('./screens/compose/compose.component').then(m => m.ComposeComponent)
            },
            {
                path: 'broadcasts',
                loadComponent: () => import('./screens/broadcasts/broadcasts.component').then(m => m.BroadcastsComponent)
            },
            {
                path: 'inbox',
                loadComponent: () => import('./screens/inbox/inbox.component').then(m => m.InboxComponent)
            },
            {
                path: 'notices',
                loadComponent: () => import('./screens/notices/notices.component').then(m => m.NoticesComponent)
            },
            {
                path: 'templates',
                loadComponent: () => import('./screens/templates/templates.component').then(m => m.TemplatesComponent)
            },
            {
                path: 'analytics',
                loadComponent: () => import('./screens/analytics/analytics.component').then(m => m.AnalyticsComponent)
            },
            {
                path: 'whatsapp-analytics',
                loadComponent: () => import('./screens/whatsapp-analytics/whatsapp-analytics.component').then(m => m.WhatsAppAnalyticsComponent)
            },
            {
                path: 'whatsapp-usage',
                loadComponent: () => import('./screens/whatsapp-usage/whatsapp-usage.component').then(m => m.WhatsAppUsageComponent)
            },
            {
                path: 'settings',
                loadComponent: () => import('./screens/settings/settings.component').then(m => m.SettingsComponent)
            }
        ]
    },
    { path: '**', redirectTo: '' }
];
